import React, { FC } from 'react';

import boatCategories from 'src/common/boatCategories';
import BoatCapacity from '../BoatCapacity';
import BoatCategory from '../BoatCategories';
import { FullBoatSearchDetail } from '../../../common/types/api/v4/boats/search';

import styles from './BoatCapacityAndCategories.module.scss';

type Boat = Pick<FullBoatSearchDetail, 'primary_category' | 'primary_subcategory'>;

export type BoatCapacityAndCategoryProps = {
  capacity: number;
  boat: Boat;
};

const BoatCapacityAndCategory: FC<BoatCapacityAndCategoryProps> = ({
  capacity,
  boat,
}) => (
  <div className={styles.root}>
    <BoatCapacity capacity={capacity} />
    <BoatCategory
      primaryCategoryId={boat.primary_category}
      secondaryCategoryId={boat.primary_subcategory}
      primaryCategorySlug={boatCategories[boat.primary_category]}
    />
  </div>
);

export default BoatCapacityAndCategory;
